import { apiGet, apiPost } from "./apiClient";

export function loginCustomer(payload) {
  return apiPost("/customer-auth/login", payload);
}

export function getCurrentCustomer() {
  return apiGet("/customer-auth/me");
}

export function getCustomerInstitutions() {
  return apiGet("/customer-auth/institutions");
}